import { useAppScope } from "master";
import React from "react";

export const PageHeader = ({
  titleEndComponent = null,
  title = "",
  subTitle = "",
  isPageEmpty = true
}) => {
  const { isMWCD } = useAppScope();
  return (
    <div className="col-12">
      {(title || isMWCD) && (
        <div className={`${isPageEmpty ? "no_padding_margin" : "mt-3"} inner-page-header d-flex justify-content-between align-items-center flex-wrap `}>
          <div className="page-header-left">
            <h2 className="page-title ellipsis-text m-0">{title}</h2>
            {subTitle && <div className="sub-title">{subTitle}</div>}
          </div>

          {titleEndComponent && (
            <div className="page-header-right d-flex align-items-center">
              {titleEndComponent}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
